/* eslint-disable */

/**
 * 去掉链接上的 http 头
 * @param {string} value
 */
export const overHTTPS = value => value && value.split(/http\:|https\:/)[1];
